import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import gsap from 'gsap'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const animateShow = (element: HTMLDivElement, onComplete: () => void) => {
        gsap.set(element, {
            opacity: 0,
        })

        gsap.to(element, {
            duration: .8,
            opacity: 1,
            onComplete,
        })
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    appear: "",
    name: "fade",
    onEnter: animateShow,
    css: false
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})